class AnimateOnScroll {

    constructor() {
        window.AOS.init({
            disable: 'mobile',
            offset: 100,
            duration: 600,
            easing: 'ease-in-sine',
            delay: 50
        });
    }

}

export default AnimateOnScroll;


// WEBPACK FOOTER //
// ./resources/js/src/core/AnimateOnScroll.js